export default __webpack_public_path__ + "static/reward-c0ddf3055588b52a905790e3f8535f52.svg";